var _defs, _rect, _rect2, _rect3, _path, _circle, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: 0,
    y1: 0,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2E90FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#1B76E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0D5DBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shineGradient",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(255,255,255,0.15)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgba(255,255,255,0.05)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dropShadow",
    x: -2,
    y: -2,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 1,
    stdDeviation: 1,
    floodOpacity: 0.3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "noise"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: 0.8,
    numOctaves: 3,
    stitchTiles: "stitch"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.015 0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "url(#bgGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "url(#shineGradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    filter: "url(#noise)",
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5H18C21.0376 7.5 23.5 9.96243 23.5 13C23.5 14.4112 22.9364 15.6949 22.0168 16.6168C22.9364 17.5387 23.5 18.8224 23.5 20.2336C23.5 23.2712 21.0376 25.7336 18 25.7336H9V7.5ZM17.5 15C19.1569 15 20.5 13.6569 20.5 12C20.5 10.3431 19.1569 9 17.5 9H12V15H17.5ZM18 24C19.6569 24 21 22.6569 21 21C21 19.3431 19.6569 18 18 18H12V24H18Z",
    fill: "white",
    filter: "url(#dropShadow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8,
    r: 2,
    fill: "white",
    filter: "url(#dropShadow)",
    opacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d96964eac26af4f8f75dee5a4f79b56e.svg";
export { ForwardRef as ReactComponent };